export default "__VITE_ASSET__DizXt$Ta__"